module.exports = __webpack_public_path__ + "img/magazine57.cf86411b.jpg";